import * as React from "react";
import { Edit, type EditProps } from "react-admin";
import { Box, Typography } from "@mui/material";
import { layout } from "./tokens";

type Props = EditProps & {
  aside?: React.ReactNode;
};

export function SectionHeader({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h6" sx={{ mb: 0.5 }}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
}

export function AppEdit({ children, aside, ...props }: Props) {
  return (
    <Edit
      {...props}
      emptyWhileLoading
      aside={
        aside ? (
          <Box
            sx={{
              width: { xs: "100%", lg: layout.edit.asideWidth },
              maxWidth: "100%",
              mt: 0,
            }}
          >
            {aside}
          </Box>
        ) : undefined
      }
      sx={{
        "& .RaEdit-main": {
          alignItems: "flex-start",
          justifyContent: { xs: "flex-start", lg: "center" },
          gap: layout.edit.gap,
        },
        "& .RaEdit-card": {
          width: { xs: "100%", lg: layout.edit.formWidth },
          maxWidth: "100%",
          flex: "0 0 auto",
          borderRadius: layout.card.radius,
          boxShadow: "none",
          backgroundImage: "none",
          border: "1px solid",
          borderColor: "divider",
        },
      }}
    >
      {children}
    </Edit>
  );
}
